import * as React from "react";
import { clsx } from 'clsx';

type TextareaFieldProps = {
    id?: string,
    name?: string,
    placeholder?: string,
    value?: string | number,
    required?: boolean,
    classes?: string,
    disabled?: boolean,
    readonly?: boolean,
    hasError?: boolean,
    errorMessage?: string,
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export function TextArea ({
    id,
    name,
    placeholder,
    value,
    classes,
    required,
    disabled,
    readonly,
    hasError,
    errorMessage,
    onChange = (e) => {},
}: TextareaFieldProps) {

    function handleChange (e: React.ChangeEvent<HTMLTextAreaElement>) {
        if (onChange) onChange(e);
    }

    return (
        <div>
      <textarea
          id={id}
          data-testid={id}
          className={clsx('form-field', {
              'has-error': hasError,
              'disabled': disabled
          })}
          name={name}
          value={value}
          placeholder={placeholder}
          required={required}
          readOnly={readonly}
          disabled={disabled}
          onChange={handleChange}
      />

            {(hasError && errorMessage) &&
                <div className="form-field__error-message">
                    {errorMessage}
                </div>
            }
        </div>
    );
};
